(function () {
  'use strict';

  // INDIV-PRICE-2: Kundenindividuelle B2B-Preise auf Produktkarten (Collection-
  // Seiten, Suchergebnisse, Predictive-Search-Dropdown, Related/Complementary).
  // Die Produktdetail-Seite (Einzelpreis + Variantenmatrix) und der Warenkorb
  // werden weiterhin von b2b-prices.js / variant-matrix.js bedient — dieses Modul
  // fasst NUR Preise innerhalb von .card-wrapper und .predictive-search an.
  //
  // Quelle der SKU: price.liquid setzt data-b2b-sku (repräsentative/günstigste
  // Variante = der angezeigte "Ab"-Preis) und optional data-b2b-varies.

  var cfg = window.b2bConfig;
  if (!cfg || !cfg.isB2B || !cfg.email || !cfg.apiKey || !cfg.apiBase) return;

  var API_BASE = cfg.apiBase;
  var API_KEY  = cfg.apiKey;
  var EMAIL    = cfg.email;

  // SKU → CHF (Netto, kundenindividuell). Cache über die Seitenlebensdauer, damit
  // Facetten-/Pagination-Re-Renders dieselbe SKU nicht erneut abfragen.
  var priceCache = {};

  // ⚠️ Der Scope ist eine Positivliste, und was nicht darin steht, behält STILL den
  // Listenpreis — ohne Fehler, ohne Skeleton. Deshalb jede Karten-Art hier führen.
  // .product-navigation (2026-09-22): das Vor/Zurück-Popup über dem PDP-Titel rendert
  // eine Produktkarte, deren Container `product-card-wrapper` heisst — NICHT
  // `card-wrapper`. CSS-Klassen sind exakte Tokens, `.card-wrapper` trifft
  // `product-card-wrapper` nicht. Der data-b2b-sku-Marker war da, wurde aber nie gelesen.
  var SCOPE_SELECTOR = [
    '.card-wrapper [data-b2b-sku]:not([data-b2b-done])',
    '.predictive-search [data-b2b-sku]:not([data-b2b-done])',
    '.product-navigation [data-b2b-sku]:not([data-b2b-done])'
  ].join(', ');

  // Kaufmännisch auf `dec` Nachkommastellen runden. Nötig, weil toFixed() auf
  // Double-Werten ABSCHNEIDET statt zu runden: (0.075).toFixed(2) === "0.07",
  // obwohl der Abacus-Preis 0.075 kaufmännisch 0.08 ergibt (so rechnet auch
  // DraftOrderBuilder mit round($vp * $cf / $gf, 2) im Bestellpfad). toPrecision(12)
  // glättet den Binärfehler vor dem Runden → 0.075→0.08, 1.005→1.01, 0.145→0.15.
  function roundDec(n, dec) {
    if (window.SU) return window.SU.roundDec(n, dec);
    var d = (dec === undefined) ? 2 : dec;
    var x = parseFloat(n);
    if (!isFinite(x)) return x;
    var f = Math.pow(10, d);
    return Math.round(Number((x * f).toPrecision(12))) / f;
  }

  function formatPrice(amount) {
    var num = roundDec(amount, 2);
    return 'CHF ' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function fetchPrices(skus) {
    var url = API_BASE + '/api/b2b/customer-prices?email=' + encodeURIComponent(EMAIL);
    skus.forEach(function (s) { url += '&skus[]=' + encodeURIComponent(s); });
    return fetch(url, { headers: { 'X-Api-Key': API_KEY } })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        return { prices: result.prices || result, level: result.fallback_level };
      });
  }

  function applyToElement(el, price, varies) {
    // Skeleton immer lösen, sobald ein echter Preis vorliegt (auch im idempotenten Fall).
    el.classList.remove('b2b-price-pending');
    // Idempotenz: bei bereits angezeigtem gleichem Preis nichts tun (kein Flackern
    // beim SWR-Revalidate).
    var shownKey = String(parseFloat(price));
    if (el.dataset.b2bShown === shownKey) return;
    el.dataset.b2bShown = shownKey;
    // List-Vergleichspreis (durchgestrichen) entfernen — B2B hat keinen Streichpreis.
    el.querySelectorAll('s').forEach(function (s) { s.remove(); });
    var text = formatPrice(price);
    if (varies) text = (window.fromPrefixCap || 'Ab ') + text;
    el.querySelectorAll('.price-item--regular, .price-item--last').forEach(function (item) {
      item.textContent = text;
    });
    // Pro-Einheit-Zeile (Stück/Meter) auf den B2B-Preis nachrechnen — sonst bliebe sie listenbasiert.
    var qty = parseFloat(el.getAttribute('data-su-qty') || '0');
    var hl = el.querySelector('.price__unit-headline');
    if (hl && qty > 0) {
      // Auto-Normalisierung: Abacus liefert je Artikel ENTWEDER den Packpreis ODER bereits
      // den Pro-Einheit-Preis (FindProductPrice-Einheit ist artikelabhängig, kein Signal in
      // der Antwort). Gegen den Gast-Packpreis (data-su-pack, in Rappen) entscheiden:
      // nur teilen, wenn der B2B-Preis Packgrösse hat (P > Pack/√qty), sonst direkt.
      var P = parseFloat(price);
      var packChf = parseFloat(el.getAttribute('data-su-pack') || '0') / 100;
      // Set-Produkte: der B2B-Preis IST der Set-Preis → niemals durch qty teilen ("/ Set").
      var isSet = el.getAttribute('data-is-set') === '1';
      // Pack- vs. Pro-Einheit: EINE Wahrheit in assets/unit-price.js (window.SU).
      // Set-Produkte: der B2B-Preis IST der Set-Preis → niemals durch qty teilen ("/ Set").
      var per = window.SU
        ? window.SU.normalize(P, packChf, qty, { isSet: isSet }).perUnit
        : (isSet ? P : ((packChf > 0 && qty > 1 && (P > packChf / Math.sqrt(qty) || P * qty > packChf * 1.25)) ? (P / qty) : P));
      var base = el.getAttribute('data-su-base') || 'Stück';
      var prefix = el.getAttribute('data-su-varies') === 'true' ? (window.fromPrefix || 'ab ') : '';
      var baseDisp = (window.unitLabel ? window.unitLabel(base) : base);
      // Abgeleiteter Einheitspreis: shop-weit 3 Nachkommastellen (window.SU.unitPrice; das
      // Liquid-Gegenstück in snippets/price.liquid ist money-dec mit dec: 3).
      hl.textContent = prefix + 'CHF ' + (window.SU ? window.SU.unitPrice(per, isSet ? 1 : qty) : roundDec(per, (qty > 1 && !isSet) ? 3 : 2).toFixed((qty > 1 && !isSet) ? 3 : 2)) + ' / ' + baseDisp;
    }
    // Sale-Styling neutralisieren, damit kein irreführendes Rabatt-Layout bleibt.
    el.classList.remove('price--on-sale', 'volume-pricing--sale-badge');
  }

  function processAll() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SCOPE_SELECTOR));
    if (!els.length) return;

    var pending = {}; // sku → [elements]
    els.forEach(function (el) {
      var sku = el.getAttribute('data-b2b-sku');
      if (!sku) { el.setAttribute('data-b2b-done', '1'); return; }
      el.setAttribute('data-b2b-done', '1'); // markieren, bevor async läuft (kein Doppel-Fetch)
      var varies = el.getAttribute('data-b2b-varies') === 'true';
      if (Object.prototype.hasOwnProperty.call(priceCache, sku)) {
        var cached = priceCache[sku];
        if (cached !== null && cached !== undefined) applyToElement(el, cached, varies);
        return;
      }
      (pending[sku] = pending[sku] || []).push({ el: el, varies: varies });
    });

    var skus = Object.keys(pending);
    if (!skus.length) return;

    // SWR Schritt 1: persistente Cache-Treffer SOFORT anzeigen (kein Flash von
    // Listenpreis), die SKUs aber trotzdem im Fetch unten revalidieren.
    var cachedSkus = {};
    if (window.B2BPriceCache) {
      var hits = window.B2BPriceCache.getMany(skus);
      Object.keys(hits).forEach(function (sku) {
        cachedSkus[sku] = true;
        var p = hits[sku].price;
        pending[sku].forEach(function (rec) { applyToElement(rec.el, p, rec.varies); });
      });
    }

    // Ohne Cache-Treffer: Skeleton auf der Karte, bis der Individualpreis geladen ist
    // (verhindert, dass kurz der Listenpreis als final erscheint). Fail-safe: nach 5 s lösen.
    var pendingEls = [];
    skus.forEach(function (sku) {
      if (cachedSkus[sku]) return;
      pending[sku].forEach(function (rec) { rec.el.classList.add('b2b-price-pending'); pendingEls.push(rec.el); });
    });
    var failSafe = setTimeout(function () {
      pendingEls.forEach(function (el) { el.classList.remove('b2b-price-pending'); });
    }, 5000);

    // SWR Schritt 2: immer live revalidieren und Cache aktualisieren.
    fetchPrices(skus).then(function (res) {
      clearTimeout(failSafe);
      var prices = res.prices || {};
      skus.forEach(function (sku) {
        var price = prices[sku];
        priceCache[sku] = (price === undefined) ? null : price;
        if (price === null || price === undefined) return;
        pending[sku].forEach(function (rec) { applyToElement(rec.el, price, rec.varies); });
      });
      // Skeleton IMMER von allen behandelten Karten lösen — auch bei null/undefined-Preis
      // (dann Listenpreis zeigen). Sonst bliebe eine Karte dauerhaft im Skeleton hängen,
      // da der Fail-safe oben bereits gecancelt wurde.
      pendingEls.forEach(function (el) { el.classList.remove('b2b-price-pending'); });
      if (window.B2BPriceCache) window.B2BPriceCache.setMany(prices, res.level);
    }).catch(function (e) {
      clearTimeout(failSafe);
      // Bei Fehler Skeleton lösen (Listenpreis zeigen) und Markierung zurücknehmen,
      // damit ein späterer Re-Scan es erneut versucht.
      skus.forEach(function (sku) {
        pending[sku].forEach(function (rec) {
          rec.el.classList.remove('b2b-price-pending');
          rec.el.removeAttribute('data-b2b-done');
        });
      });
      if (window.console) console.warn('[B2B] card price fetch failed:', e);
    });
  }

  // Debounced Re-Scan: deckt Predictive-Search-Injection, Facetten-/Sortier-
  // Re-Render (ProductGridContainer.innerHTML), Pagination und Quick-Add ab —
  // ohne jede Theme-Datei einzeln zu haken.
  var _t = null;
  function scheduleProcess() {
    if (_t) return;
    _t = setTimeout(function () { _t = null; processAll(); }, 120);
  }

  function init() {
    processAll();
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { scheduleProcess(); return; }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scheduleProcess);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
